@use "stylesheets/utility/variables";

.formWrapper {
  margin: 40px auto;
  max-width: 450px;

  @media screen and (min-width: variables.$laptop) {
    margin: 195px auto 0;
  }

  .formTitle {
    margin-top: 0;
  }

  .description {
    margin-bottom: 0;
  }

  .singleEmail {
    font-weight: bold;
    margin-bottom: 15px;
  }

  .radioWrapper {
    margin-top: 15px;
  }

  .promptText {
    margin-bottom: 20px;
  }
}
